export enum PaymentCode {
  PaymentSuccess = 20100,
  PaymentDeclined = 20101,
  PaymentDeclinedGeneric = 20102,
  PaymentInsufficientFunds = 20103,
  PaymentDoNotHonor = 20104,
  PaymentInvalidCard = 20105,
  PaymentTransactionNotPermitted = 20106,
  PaymentIncorrectPin = 20107,
  PaymentRestrictedCard = 20108,
  PaymentInvalidAccountNumber = 20109,
  PaymentCardAuthorizationCreditOnly = 20110,
  PaymentVoidError = 20111,
  PaymentReversalError = 20112,
  PaymentInvalidAmount = 20113,
  PaymentTransactionError = 20114,
  PaymentTokenError = 20115,
  PaymentAbandoned = 20116,
  PaymentCardNotActivated = 20117,
  PaymentCommitError = 20118,
  PaymentRefundError = 20119,
  PaymentError = 20120,
  PaymentCancelled = 20121,
  PaymentSignatureRequired = 20122,
  PaymentFormatError = 20123,
  PaymentSwipedCardHasChip = 20124,
  PaymentCardTypeUnsupported = 20125,
  PaymentPartialApproval = 20126,
  PaymentInvalidRequest = 20127,
  PaymentInvalidEntryMethod = 20128,
  PaymentNotCompleted = 20129,
  PaymentLiveCardUsedInTest = 20150,
  PaymentCardZipInvalid = 20151,
  PaymentCardCvvInvalid = 20152,
  PaymentCardExpired = 20153,
  PaymentCardNumberInvalid = 20154,
  PaymentCardCallForAuthorization = 20155,
  PaymentProcessingError = 20160,
  PaymentTerminalError = 20200,
  PaymentTerminalEncryptionError = 20201,
  PaymentTerminalCardRemoved = 20202,
  PaymentTerminalChipReadingError = 20203,
  PaymentTerminalTimeout = 20204,
  PaymentTerminalPayloadError = 20205,
  PaymentTerminalNotConnected = 20206,
  PaymentTerminalCancelError = 20207,
  PaymentTerminalOfflineError = 20208,
  PaymentMerchantError = 20300,
  PaymentIntegrationInvalidCredentials = 20350,
  PaymentIntegrationInvalid = 20351,
  PaymentSystemError = 20400,
  PaymentIframeError = 20401,
  PaymentUnhandledError = 20500,
  PaymentHandledUnknown = 20600,
}
